define('OutSystems/ClientRuntime/modules/Database/Metadata/MetadataTableInitializer',["require", "exports", "tslib", "../../../Logger", "./MetadataBackupTableInfo", "./MetadataTableInfo"], function (require, exports, tslib_1, Logger, MetadataBackupTableInfo_1, MetadataTableInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MetadataTableInitializer = {
        isNeeded: function (tx) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, tx.existsTable(MetadataTableInfo_1.default)];
                    case 1: return [2, !(_a.sent())];
                }
            });
        }); },
        run: function (tx) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.trace(this, "Running initializer for entity meta info table.");
                        return [4, tx.createTable(MetadataTableInfo_1.default)];
                    case 1:
                        _a.sent();
                        return [4, tx.createTable(MetadataBackupTableInfo_1.default)];
                    case 2:
                        _a.sent();
                        Logger.trace(this, "Initializer for entity meta info table ran successfully.");
                        return [2];
                }
            });
        }); },
    };
    exports.default = MetadataTableInitializer;
});
//# sourceMappingURL=MetadataTableInitializer.js.map;
